<div class="reset-page screen-bottom-halo">
  <div class="logo-container">
    <img class="logo-icon" src="assets/images/explain-logo-900.svg" alt="explain_logo" />
    <img class="logo-text" src="assets/images/explain-text-900.svg" alt="explain_text" />
  </div>

  <div class="reset-card expired-card">
    <!-- Icon (maquette: clock in circle) -->
    <div class="expired-icon-wrap">
      <i class="ph ph-clock expired-icon" aria-hidden="true"></i>
    </div>

    <!-- Text block: title + 2 paragraphs (maquette gap 12px, centered) -->
    <div class="expired-text-block">
      <h2 class="expired-heading">{{ 'reset-password.expired-heading' | translate }}</h2>
      <p class="expired-line">{{ 'reset-password.expired-line1' | translate }}</p>
      <p class="expired-line">{{ 'reset-password.expired-line2' | translate }}</p>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="auth-form expired-form">
      <div class="form-field">
        <label for="email" class="field-label">{{ 'reset-password.email' | translate | uppercase }}</label>
        <input
          type="text"
          formControlName="email"
          class="field-input"
          id="email"
          [ngClass]="{ 'field-input--error': isError }"
          autocomplete="email"
          data-cy="reset-password-expired-email-input"
        />
        <div *ngIf="submitted && f['email'].errors" class="error-banner">
          <i class="ph ph-warning error-icon" aria-hidden="true"></i>
          <span class="error-text">{{ 'reset-password.no-match' | translate }}</span>
        </div>
      </div>

      <!-- CTA button: default / sending / sent (green) / cooldown (disabled) -->
      <button
        type="submit"
        [disabled]="loading || showCooldownState"
        class="btn-expired-cta"
        [ngClass]="{
          'btn-expired-cta--sent': showSentState,
          'btn-expired-cta--cooldown': showCooldownState,
        }"
        data-cy="reset-password-expired-submit"
      >
        <ng-container *ngIf="resendState === 'sending'">
          <i class="ph ph-circle-notch ph-spin btn-cta-icon" aria-hidden="true"></i>
          <span>{{ 'reset-password.sending-in-progress' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="showSentState">
          <i class="ph ph-check btn-cta-icon" aria-hidden="true"></i>
          <span>{{ 'reset-password.email-sent-label' | translate }}</span>
        </ng-container>
        <ng-container *ngIf="showCooldownState">
          <i class="ph ph-envelope btn-cta-icon" aria-hidden="true"></i>
          <span>{{ 'reset-password.resend-cooldown' | translate: { seconds: cooldown } }}</span>
        </ng-container>
        <ng-container *ngIf="resendState === 'idle' && cooldown === 0">
          <i class="ph ph-envelope btn-cta-icon" aria-hidden="true"></i>
          <span>{{ 'reset-password.receive-new-link' | translate }}</span>
        </ng-container>
      </button>

      <!-- Feedback after send (maquette: -mt-16px) -->
      <p *ngIf="showCheckInboxHint" class="expired-feedback">
        {{ 'reset-password.check-inbox-hint' | translate }}
      </p>

      <!-- Back link (maquette: arrow + "Revenir à la connexion") -->
      <a [routerLink]="['/login']" class="link-back ml-3" data-cy="reset-password-expired-back-link">
        {{ 'reset-password.back-to-login' | translate }}
      </a>
    </form>
  </div>
</div>
